










import Vue from "vue";
import PulsingChip from "@/components/PulsingChip.vue";

import { getInstallationConnectivityStatusIconColor } from "@/utility/Constants";
import { connectivityStatusEnumLabel } from "@/model/data/status/ConnectivityStatusEnum";

export default Vue.extend({
    components: {
        PulsingChip,
    },
    props: {
        status: Number,
        outlined: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        connectivityStatusEnumLabel,
        getInstallationConnectivityStatusIconColor,
    },
});
